module.exports = __webpack_public_path__ + "static/media/storepreviewStoreOne.528ea2a9.svg";